import { render } from "./CourseInfo.vue?vue&type=template&id=35b8095e&scoped=true"
import script from "./CourseInfo.vue?vue&type=script&lang=js"
export * from "./CourseInfo.vue?vue&type=script&lang=js"

import "./CourseInfo.vue?vue&type=style&index=0&id=35b8095e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b8095e"]])

export default __exports__